import { environment } from '~/util/environment';
import { fetcher } from '~/util/fetcher';

const { backendUrl } = environment;

type LoginResponse = LoginResponseSuccess | LoginResponseFailure;

interface LoginResponseSuccess {
  success: true;
  token: string;
}

interface LoginResponseFailure {
  success: false;
  errors: Array<{ message: string, key?: string }>;
}

export const fetchAuthenticationToken = ( email: string, password: string, permission: string ): Promise<LoginResponse> => {
  const url = `${backendUrl}/authenticate`;

  const options = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify( { email, password, permission } ),
  };

  return fetcher( url, options ) as Promise<LoginResponse>;
};

/** @deprecated Deprecated because it's not in use. If you want to use it, just check that it still works as intended. */
export const resetRequest = ( email: string, redir: string ) => {
  throw new Error( 'This function is not in use, but might be useful, so I\'m keeping it around.' );

  const url = `${backendUrl}/authenticate/forgot`;
  const options = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify( { email, redir } ),
  };
  return fetcher( url, options );
};

/** @deprecated Deprecated because it's not in use. If you want to use it, just check that it still works as intended. */
export const resetPassword = ( password: string, token: string ) => {
  throw new Error( 'This function is not in use, but might be useful, so I\'m keeping it around.' );

  const url = `${backendUrl}/authenticate/reset`;
  const options = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify( { password, token } ),
  };
  return fetcher( url, options );
};

/** @deprecated Deprecated because it's not in use. If you want to use it, just check that it still works as intended. */
export const setPassword = ( current: string, password: string, token: string ) => {
  throw new Error( 'This function is not in use, but might be useful, so I\'m keeping it around.' );

  const url = `${backendUrl}/authenticate/assign-password`;
  const options = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify( { current, password } ),
  };
  return fetcher( url, options );
};

/** @deprecated Deprecated because it's not in use. If you want to use it, just check that it still works as intended. */
export const createAccount = ( account: Record<string, unknown> ) => {
  throw new Error( 'This function is not in use, but might be useful, so I\'m keeping it around.' );

  const url = `${backendUrl}/account`;
  const options = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify( { ...account } ),
  };
  return fetcher( url, options );
};

/** @deprecated Deprecated because it's not in use. If you want to use it, just check that it still works as intended. */
export const requestConfirm = ( email: string, redir: string ) => {
  throw new Error( 'This function is not in use, but might be useful, so I\'m keeping it around.' );

  const url = `${backendUrl}/account/request-confirm`;
  const options = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify( { email, redir } ),
  };
  return fetcher( url, options );
};

/** @deprecated Deprecated because it's not in use. If you want to use it, just check that it still works as intended. */
export const confirmAccount = ( token: string, password: string ) => {
  throw new Error( 'This function is not in use, but might be useful, so I\'m keeping it around.' );

  const url = `${backendUrl}/account/confirm`;
  const userType = 'EM';
  const options = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify( { token, password, userType } ),
  };
  return fetcher( url, options );
};
